import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { RolesService } from 'src/app/services/roles-service/roles.service';

@Component({
  selector: 'app-roles-new-role-creation-card',
  templateUrl: './roles-new-role-creation-card.component.html',
  styleUrls: ['./roles-new-role-creation-card.component.scss']
})
export class RolesNewRoleCreationCardComponent implements OnInit, OnDestroy {

  @Input() menuSections;
  @Input() roles;
  selectedSections;
  showButton: boolean;
  addNewRoleSubscription: Subscription;
  basicDataForm = new FormGroup({
    name: new FormControl(null, Validators.required)
  });

  constructor(private spinnerService: SpinnerService,
              private snackbarService: SnackBarService,
              private router: Router,
              private rolesService: RolesService,
              private activatedRoute: ActivatedRoute,
              private userStorageService: UserStorageService) {
    this.selectedSections = new Array();
    this.showButton = true;
  }

  ngOnInit() { }

  public addNewRole() {
    this.showButton = false;
    this.spinnerService.show('role-new-spinner');
    const validation = this.validateForm();
    if (validation === true) {
      this.addNewRoleSubscription = this.rolesService.addNewRole(this.roles[0].RoleInternalId, this.userStorageService.getCompanyData().CompanyCode, this.basicDataForm.get('name').value, this.selectedSections).subscribe(
        (res) => {
          this.snackbarService.open('roles-page.snackbar messages.add role success', 'success');
          this.spinnerService.hide('role-new-spinner');
          this.router.navigate(['../roles'], { relativeTo: this.activatedRoute.parent });
        },
        (error) => {
          this.showButton = true;
          this.spinnerService.hide('role-new-spinner');
          this.snackbarService.open(error['error']['message'], 'error');
        }
      );
    } else {
      this.showButton = true;
      this.spinnerService.hide('role-new-spinner');
      this.snackbarService.open(validation, 'error');
    }
  }

  public cancelRole() {
    this.router.navigate(['../roles'], { relativeTo: this.activatedRoute.parent });
  }
  public validateForm() {
    if (!this.basicDataForm.get('name').valid) {
      return 'roles-page.snackbar messages.name role error';
    } else {
      return true;
    }
  }

  public duallistboxOutputEventReceiver(sections) {
    const aux = new Array();
    for (const d of sections) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedSections = aux;
    }
  }

  ngOnDestroy() {
    if (this.addNewRoleSubscription) { this.addNewRoleSubscription.unsubscribe(); }
  }
}
